import { render } from "./CaricamentoLite.vue?vue&type=template&id=77527c12&scoped=true"
import script from "./CaricamentoLite.vue?vue&type=script&lang=js"
export * from "./CaricamentoLite.vue?vue&type=script&lang=js"

import "./CaricamentoLite.vue?vue&type=style&index=0&id=77527c12&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Desktop/Progetti/ask_landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77527c12"]])

export default __exports__